import { ALLOWED_DISPLAY_FORMATS } from '../constants';
import type { AttributeType, DisplayFormat } from '../types';

/**
 * Форматы отображения, допустимые для типа данных. Пустой список — тип формат не принимает.
 */
export const getAllowedDisplayFormats = (dataType?: AttributeType | string | null): DisplayFormat[] => {
  if (!dataType) return [];
  const allowed = ALLOWED_DISPLAY_FORMATS[dataType as keyof typeof ALLOWED_DISPLAY_FORMATS];
  return allowed ? [...allowed] : [];
};

/**
 * Сочетается ли формат отображения с типом данных. Отсутствие формата допустимо для любого типа.
 */
export const isDisplayFormatAllowed = (
  dataType?: AttributeType | string | null,
  displayFormat?: DisplayFormat | null,
): boolean => {
  if (!displayFormat) return true;
  return getAllowedDisplayFormats(dataType).includes(displayFormat);
};
